/**
 * Parse a vertical column pasted from Excel / Google Sheets into numeric values.
 * Each line is one cell; trailing empty lines are dropped.
 */
export function parseColumnPaste(text: string): number[] {
  if (!text || !text.trim()) return [];

  const lines = text.split(/\r?\n/);
  while (lines.length > 0 && lines[lines.length - 1].trim() === '') {
    lines.pop();
  }

  const values: number[] = [];
  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) continue;

    const normalized = trimmed.replace(/\s/g, '').replace(',', '.');
    const num = parseFloat(normalized);
    if (!Number.isFinite(num)) {
      console.warn('[parseColumnPaste] Skipping non-numeric value:', line);
      continue;
    }
    values.push(num);
  }

  return values;
}
